import { combineReducers, Action, createFeatureSelector } from '@ngrx/store';

import {State as CoreState} from '@emm/core/store/core.reducer';
import {attributeReducer, attributesFeatureKey, AttributeState} from '@emm/menu/store/attributes/attributes.reducer';
import {baseFeatureKey, MenuBaseState, menuBaseReducer as baseReducer} from './base/menu-base.reducer';
import {
    changeSetsFeatureKey,
    changeSetsReducer,
    ChangeSetsState
} from '@emm/menu/store/change-sets/change-sets.reducer';
import {consumerFeatureKey, consumerReducer, ConsumerState} from '@emm/menu/store/consumer/consumers.reducer';
import {
    consumerTypesFeatureKey,
    consumerTypesReducer,
    ConsumerTypesState
} from './consumer-types/consumer-types.reducer';
import {
    featureScopeFeatureKey,
    featureScopeReducer,
    FeatureScopeState
} from '@emm/menu/store/feature-scope/feature-scope.reducer';
import {
    itemChildrenFeatureKey,
    itemChildrenReducer,
    ItemChildrenState
} from '@emm/menu/store/item-children/item-children.reducer';
import {itemDetailFeatureKey, ItemDetailState, itemDetailReducer} from '@emm/menu/store/item-detail/item-detail.reducer';
import {itemsFeatureKey, itemsReducer, ItemsState} from '@emm/menu/store/items/items.reducer';
import {
    locationSetTypesFeatureKey, locationSetTypesReducer,
    LocationSetTypesState
} from '@emm/menu/store/location-set-types/location-set-types.reducer';
import {locationSetsFeatureKey, locationSetsReducer, LocationSetsState} from './location-sets/location-sets.reducer';
import {submenusFeatureKey, submenusReducer, SubmenusState} from '@emm/menu/store/submenus/submenus.reducer';

export const menuFeatureKey = 'menu';

export interface MenuState {
    [attributesFeatureKey]: AttributeState;
    [baseFeatureKey]: MenuBaseState;
    [changeSetsFeatureKey]: ChangeSetsState;
    [consumerFeatureKey]: ConsumerState;
    [consumerTypesFeatureKey]: ConsumerTypesState;
    [featureScopeFeatureKey]: FeatureScopeState;
    [itemChildrenFeatureKey]: ItemChildrenState;
    [itemDetailFeatureKey]: ItemDetailState;
    [itemsFeatureKey]: ItemsState;
    [locationSetsFeatureKey]: LocationSetsState;
    [locationSetTypesFeatureKey]: LocationSetTypesState;
    [submenusFeatureKey]: SubmenusState;
}

export interface State extends CoreState {
    [menuFeatureKey]: MenuState;
}

export function menuReducers(state: MenuState | undefined, action: Action) {
    return combineReducers({
        [attributesFeatureKey]: attributeReducer,
        [baseFeatureKey]: baseReducer,
        [changeSetsFeatureKey]: changeSetsReducer,
        [consumerFeatureKey]: consumerReducer,
        [consumerTypesFeatureKey]: consumerTypesReducer,
        [featureScopeFeatureKey]: featureScopeReducer,
        [itemChildrenFeatureKey]: itemChildrenReducer,
        [itemDetailFeatureKey]: itemDetailReducer,
        [itemsFeatureKey]: itemsReducer,
        [locationSetTypesFeatureKey]: locationSetTypesReducer,
        [locationSetsFeatureKey]: locationSetsReducer,
        [submenusFeatureKey]: submenusReducer,
    })(state, action);
}

export const getMenuState = createFeatureSelector<State, MenuState>(menuFeatureKey);
